<template>
  <div class="box">
    <day title="视频带货-数据概览" @addDay="addDay" :dayNum="dayNum"></day>
    <div class="border">
      <div></div>
    </div>
    <tablist :info="listTab"></tablist>
    <div class="list">
      <div class="title">视频带货-商品列表</div>
      <form action="/">
      <van-search v-model="searchText" placeholder="请输入搜索关键词"   @search="search" @blur="search"/>
     </form>
      <div class="list-box" v-if="info.length">
        <van-list :finished="finished" :finished-text="finishedText"  @load="query()">
       <list v-for="(item,index) in info" :key="index" :info="item" :index="index + 1"></list>
        </van-list>
      </div>
      <NoneData v-else propsText="该主播在所选条件内没有带货视频" :height="5" :imgSize="1.65"/>
    </div>
  </div>
</template>

<script>
import day from '../components/day'
import tablist from '../components/tablist'
import list from '../components/list.vue'
export default {
  components:{
    day,
    tablist,
    list
  },
  data() {
    return {
      info:[],
      count:0,
      salesOpus:{},
      dayNum:30,
      searchText:'',
      page:{
        pageNum:1,
        pageSize:25,
        
      }
    }
  },
  computed:{
    finished(){
      // return this.count === this.info.length
      return true
    },
    isVip(){
      return this.$store.state.userLevel && this.$store.state.userLevel < 1000
    },
    finishedText: ( _this = this) => ( !_this.isVip ? '升级权益查看更多数据' : '没有更多了'),
    listTab() {
      return [
        [
          {text:'带货视频',value:this.salesOpus.opusCount},
          {text:'关联商品',value:this.salesOpus.commodityCount},
          {text:'关联店铺',value:this.salesOpus.shopCount},
          {text:'关联品牌',value:this.salesOpus.brandCount},
        ]
        ,
        [
          {text:'平均时长',value:this.Time(this.salesOpus.avgDuration)},
          {text:'平均播放',value:this.$retainWan(this.salesOpus.avgViews)},
          {text:'平均点赞',value:this.$retainWan(this.salesOpus.avgLikes)},
          {text:'平均评论',value:this.$retainWan(this.salesOpus.avgComments)},
        ]
      ]
    }
  },
  mounted() {
    this.getInfo()
  },
  methods: {
    addDay(val) {
      this.dayNum = val
      this.getInfo()
    },
    Time(tiem) {
      // const HH =Math.floor(tiem / 3600)
      const MM = Math.floor((tiem) / 60)
      const SS = Math.floor(((tiem % 60)))
      return MM ? `${MM}分${SS}秒` : `${SS}秒`
    },
    search() {
      this.getInfo()
    },
    getInfo() {
      this.$showLoading()
      const today = new Date();
      const yesterday = new Date(today.getFullYear(), today.getMonth(), today.getDate() - 1);
      const formattedYesterday = `${yesterday.getFullYear()}${String(yesterday.getMonth() + 1).padStart(2, '0')}${String(yesterday.getDate()).padStart(2, '0')}`;
      this.$get({
          road: 'opusStatistic',
          data: { anchorId: this.$route.params.id },
          params: { timeMode: this.dayNum, time: formattedYesterday },
          version: 'v22'
        }).then(res => {
         this.salesOpus = res.data.salesOpus
        }).finally(() => {
          this.$toast.clear()

        })

        this.$get({
          road: 'opusCommodity',
          data: { anchorId: this.$route.params.id },
          params: { timeMode: this.dayNum, time: formattedYesterday ,keyword:this.searchText,...this.page},
          version: 'v22'
        }).then(res => {
          this.info = res.data.data
          this.count = res.data.paging.count
        }).finally(() => {
          this.$toast.clear()
        })
        // this.$hideLoading()
    }
  }
}
</script>

<style scoped lang="less">
/deep/.van-search__content {
  border-radius: 10px;
}
.box {
  .list-box {
    margin-top: 10px
  }
  .border {
    height: 20px;
    background-color: #fff;
    display: flex;
    align-items: center;
    justify-content: center;
    div {
      width: 351px;
      height: 0.5px;
      background-color: #EDEDEE;
    }
  }
  .list {
    background-color: #fff;
    margin-top: 12px;
    padding: 16px 12px;
    .title {
      font-size: 14px;
      font-weight: 500;
      color:#141B27;
      margin-bottom: 12px;
    }
    
  }
}
</style>
